import { render, staticRenderFns } from "./LogosAdditionalAnswer.vue?vue&type=template&id=4ad511ca&scoped=true&"
import script from "./LogosAdditionalAnswer.vue?vue&type=script&lang=js&"
export * from "./LogosAdditionalAnswer.vue?vue&type=script&lang=js&"
import style0 from "./LogosAdditionalAnswer.vue?vue&type=style&index=0&id=4ad511ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad511ca",
  null
  
)

component.options.__file = "LogosAdditionalAnswer.vue"
export default component.exports